import fp from 'lodash/fp';

import { getFilters } from '../../webcommon/header/filterheader/selectors';

export const getImpactId = fp.get('impactAnalysis.idSummary.impactAnalysisId');

export const getInitialised = fp.get('impactAnalysis.idSummary.initialised');

export const getSummaryTrades = fp.get('impactAnalysis.idSummary.tradedPricedToday.trades');

export const getSummaryOriginalTrades = fp.get('impactAnalysis.idSummary.tradedPricedToday.originalTrades');

export const getSummaryImpactRows = fp.get('impactAnalysis.idSummary.impactSummaryRows');

export const getPricingParams = fp.get('impactAnalysis.idSummary.pricingParams');

export const getDateFrom = (state) => {
    const filterState = getFilters(state, 'ImpactAnalysisIdSummary');
    if (filterState) {
        const filter = filterState.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getActiveCsa = (state) => {
    const filterState = getFilters(state, 'ImpactAnalysisIdSummary');
    if (filterState) {
        const filter = filterState.find(obj => obj.definition.id === 'csa');
        if (filter) {
            if (filter.value.length > 0) {
                return filter.value[0];
            }
        }
        return '';
    }
    return '';
};
